import AsyncStorage from '@react-native-async-storage/async-storage';
import globalStore from './services/global.state';
import {getCurrentChannelId, http, VERSION_CODE} from '@utils/request';
import DeviceInfo from 'react-native-device-info';
import {BasicObject} from '@/types';
import {packageId} from '@/config';

export const setVisitor = (id: string) => {
  AsyncStorage.getItem('visitor').then(res => {
    globalStore.visitor = res || id;
    AsyncStorage.setItem('visitor', res || id);
  });
};

export const setToken = () => {
  AsyncStorage.getItem('token').then(res => {
    if (res) {
      globalStore.token = res;
    }
  });
};

export const setUserInfo = () => {
  AsyncStorage.getItem('user').then(res => {
    if (res) {
      globalStore.userInfo = JSON.parse(res);
    }
  });
};

export const setFCMToken = async (token: string) => {
  await AsyncStorage.setItem('FCMToken', token);
};

export interface VersionInfo {
  /** 版本 */
  appVersion: string;
  /** 下载地址 */
  downUrl: string;
  /** 提示文案 */
  levelContent: string;
  /** 1提示不强制,2不提示,3强更 */
  levelUp: 1 | 2 | 3;
  /** 图片url */
  popBack: string;
  /** 下载页背景图 */
  bgUrl?: string;
  /** 最新版本号 */
  versionCode?: number;
  /** App 名称 */
  appName?: string;
}

interface VersionCheckRequest {
  packageId: number;
  channelId: string;
  versionCode?: number;
}

interface LatestVersionInfo {
  downUrl: string;
}

const requestVersion = <TResponse>(versionCode?: number) => {
  return http.post<VersionCheckRequest, TResponse>('app/version/check', {
    packageId,
    channelId: getCurrentChannelId(),
    // 覆盖请求层默认版本号；undefined 序列化时会被移除。
    versionCode,
  });
};

/** App 使用当前版本号检查是否需要升级。 */
export const checkVersion = () => {
  const versionCode = Number(VERSION_CODE);
  if (!Number.isFinite(versionCode)) {
    return Promise.reject(new Error('Invalid app version code'));
  }
  return requestVersion<VersionInfo>(versionCode);
};

/** H5 不传 versionCode，获取对应渠道的 APK 完整地址。 */
export const getChannelApk = () => requestVersion<LatestVersionInfo>();

export interface PopInfo {
  createTime: number;
  id: number;
  popImg: string;
  popUrl: string;
  /** 0开启1关闭 */
  status: 0 | 1;
}

export const checkPop = () => {
  return http.post<null, PopInfo>('app/sysPop/check');
};
export interface IListEle {
  popImg: string; // 图片
  popUrl: string; //跳转信息
  /** 0开启1关闭 */
  status: 0 | 1;
  title: string;
  dailyImpressions?: number;
  bannerId: number;
}
export const checkPops = () => {
  return http.post<null, IListEle[]>('app/sysPop/checkList');
};

export const dailyRecord = () => {
  if (globalStore.isWeb) {
    http
      .post('app/user/daily/record', {
        deviceId: globalStore.visitor,
      })
      .then();
  } else if (globalStore.isAndroid) {
    DeviceInfo.getAndroidId().then((androidId: string) => {
      http
        .post('app/user/daily/record', {
          deviceId: androidId,
        })
        .then();
    });
  }
};

export const trackEndponit = (data: BasicObject) => {
  const {trackHttp} =
    require('./utils/trackRequest') as typeof import('./utils/trackRequest');
  return trackHttp.post('app/datasense/receiver/receive', {eventList: data});
};

export const tokenRoutes = [
  'GameWebView',
  'WebView',
  'Recharge',
  'Withdraw',
  'AddBank',
  'Vip',
  'Wallet',
  'Rebate',
  'Bets',
  'Transactions',
  'Transfer',
  'Notification',
  'NotificationDetail',
  'ProxyHome',
  'ProxyRules',
  'ProxyCommissionDetail',
  'ProxyTeamReport',
  'ProxyNewUser',
  'Invitation',
  'InvitationRecord',
  'InvitationRule',
  'Profile',
  'PromotionDetail',
  'Sports',
  'BetsShard',
];
